import checkPermissions from './checkPermissions';
import { GetPermissions, UseCheckPermissions } from './models/useCheckPermissions';

export default function createCheckPermissionsHook(
  getCurrentPermissions: GetPermissions
): UseCheckPermissions {
  return () => ({
    checkPermissions: (permissions?: string[] | string | null, checkAll = true): boolean =>
      checkPermissions(getCurrentPermissions(), permissions, checkAll),
  });
}
